
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, union_type, string_type, class_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_none, Cmd_batch, Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { ofNullable } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { ensureValidToken } from "../../Auth.js";
import { handleFetchError } from "../../ErrorHandling.js";
import { keyValueList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/MapUtil.js";
import { singleton, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Types_RequestProperties, Types_HttpRequestHeaders } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { toArray, empty as empty_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { fetch$ } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { addPrefix } from "../../Communication.js";
import { toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { FormState__startLoading, FormState_get_empty, StorageId_$reflection, FormState_$reflection, StorageId__get_unwrap } from "../../Shared/Shared.js";
import { SwissAthleticReportResult_$reflection } from "../../Shared/Report.js";
import { onBlobReceived, getBlob } from "../../Communication.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Button } from "../../Components/Button.js";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DownloadExcelFile", "ExportFileFetched", "BlobReceived", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Report.CustomerReports.SwissAthletic.Msg", [], Msg, () => [[], [["Item1", class_type("Fetch.Types.Response")], ["Item2", string_type]], [["Item1", class_type("Browser.Types.Blob", undefined)], ["Item2", string_type]], [["Item", class_type("System.Exception")]]]);
}

function exportExcelCmd(startDate, endDate, storageId) {
    return Cmd_OfPromise_either((tupledArg) => {
        const body_1 = tupledArg[2];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let pr;
            const tenant = ofNullable(localStorage.getItem("tenant"));
            return ((pr = ensureValidToken(), pr.then(void 0, (handleFetchError)))).then((_arg) => {
                const headers = new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
                    let matchValue;
                    return append((matchValue = _arg, (matchValue == null) ? (empty()) : singleton(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue]))), delay(() => append(singleton(new Types_HttpRequestHeaders(11, ["Content-Disposition"])), delay(() => {
                        const matchValue_1 = tenant;
                        if (matchValue_1 == null) {
                            return empty();
                        }
                        else {
                            return singleton(["X-ONE-Tenant", matchValue_1]);
                        }
                    }))));
                })), 0)]);
                const props = (body_1 == null) ? ofArray([new Types_RequestProperties(0, ["GET"]), headers]) : ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body_1]), headers]);
                return fetch$(addPrefix(tupledArg[0]), props).then((_arg_1) => (Promise.resolve([_arg_1, tupledArg[1]])));
            });
        }));
    }, [`/api/reports/swiss-athletic/user-assignment/${toString(startDate, "dd.MM.yyyy")}/${toString(endDate, "dd.MM.yyyy")}/${StorageId__get_unwrap(storageId)}`, "swiss_athletic_report.xlsx", undefined], (tupledArg_1) => (new Msg(1, [tupledArg_1[0], tupledArg_1[1]])), (Item_2) => (new Msg(3, [Item_2])));
}

class State extends Record {
    constructor(FormState, SwissAthleticReportResult, StartDate, EndDate, StorageId) {
        super();
        this.FormState = FormState;
        this.SwissAthleticReportResult = SwissAthleticReportResult;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.StorageId = StorageId;
    }
}

function State_$reflection() {
    return record_type("Report.CustomerReports.SwissAthletic.State", [], State, () => [["FormState", FormState_$reflection()], ["SwissAthleticReportResult", SwissAthleticReportResult_$reflection()], ["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")], ["StorageId", StorageId_$reflection()]]);
}

function init(swissAthleticReportResult, startDate, endDate, storageId) {
    return [new State(FormState_get_empty(), swissAthleticReportResult, startDate, endDate, storageId), Cmd_batch(empty_1())];
}

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(FormState_get_empty(), state.SwissAthleticReportResult, state.StartDate, state.EndDate, state.StorageId), getBlob(msg.fields[0], msg.fields[1], (tupledArg) => (new Msg(2, [tupledArg[0], tupledArg[1]])), (Item_2) => (new Msg(3, [Item_2])))];
        case 2: {
            onBlobReceived(msg.fields[0], msg.fields[1]);
            return [state, Cmd_none()];
        }
        case 3:
            return [new State(FormState_get_empty(), state.SwissAthleticReportResult, state.StartDate, state.EndDate, state.StorageId), Cmd_errorToast("Es ist ein Fehler aufgetreten")];
        default:
            return [new State(FormState__startLoading(state.FormState), state.SwissAthleticReportResult, state.StartDate, state.EndDate, state.StorageId), Cmd_batch(ofArray([Cmd_successToast("Der Download wurde gestartet"), exportExcelCmd(state.StartDate, state.EndDate, state.StorageId)]))];
    }
}

function ReportContent(props) {
    let elems_1;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems = [createElement(Button, {
            ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
            Label: "Excel Export",
            OnClick: props.DownloadExcelFile,
            TestId: "download-excel-file",
            Variant: "blueButton",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => singleton(createElement(InfiniteTable, {
            ColumnDefinitions: [new ColumnDefinition$1("lFDADRNR", "", "LFDADRNR", (dto) => (new CellContent(0, [dto.LFDADRNR])), "text", "text"), new ColumnDefinition$1("firstName", "", "Vorname", (dto_1) => (new CellContent(0, [dto_1.FirstName])), "text", "text"), new ColumnDefinition$1("surname", "", "Nachname", (dto_2) => (new CellContent(0, [dto_2.Surname])), "text", "text"), new ColumnDefinition$1("clothingItem", "", "Kleidungsstück", (dto_3) => (new CellContent(0, [dto_3.ClothingItem])), "text", "text"), new ColumnDefinition$1("lFDKLDNR", "", "LFDKLDNR", (dto_4) => (new CellContent(0, [dto_4.LFDKLDNR])), "text", "text"), new ColumnDefinition$1("date", "", "Datum", (dto_5) => (new CellContent(8, [dto_5.Date])), "dateRange", "date"), new ColumnDefinition$1("pieces", "", "Stück", (dto_6) => (new CellContent(0, [dto_6.Pieces])), "text", "text"), new ColumnDefinition$1("remark", "", "Bemerkung", (dto_7) => (new CellContent(0, [dto_7.Remark])), "text", "text"), new ColumnDefinition$1("category", "", "Kategorie", (dto_8) => (new CellContent(0, [dto_8.Category])), "text", "text")],
            Controls: empty_1(),
            Options: {
                BorderStyle: "row",
                CSVDownload: true,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["lFDADRNR", "asc"],
                Fullscreen: false,
                GlobalSearch: true,
                RowSelection: "disabled",
                SaveTableConfiguration: false,
                WithQueryParameters: false,
            },
            TableKey: "report-swiss-athletic",
            TableRows: toArray(props.SwissAthleticReportRows),
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function SwissAthleticReport(props) {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => init(tupledArg[0], tupledArg[1], tupledArg[2], tupledArg[3]), update, (_arg, _arg_1) => {
    }), [props.SwissAthleticReportResult, props.StartDate, props.EndDate, props.StorageId], [props.SwissAthleticReportResult]);
    const state_1 = patternInput[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems = [createElement(ReportContent, {
        DownloadExcelFile: () => {
            patternInput[1](new Msg(0, []));
        },
        FormState: state_1.FormState,
        SwissAthleticReportRows: state_1.SwissAthleticReportResult.Rows,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

